export enum CommunicationsResponseDialConferenceError {
  invalidPhone = 'invalidPhone',
  invalidCallerId = 'invalidCallerId',
}
